var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vs-button',{staticClass:"toGlitch",attrs:{"dark":""},on:{"click":_vm.connectOrDisconnect,"mouseover":_vm.overButton,"mouseleave":_vm.leaveButton}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }